<div *ngIf="showLoader" class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 container p0">
      <div class="loading-div-tiny" id="freshpass-loading">
          <div class="loading-spinner">
              <div alt="Loading..." class="large progress">
                  <div class="prog1">
                      <div class="prog2"></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
<div class="cancel-error-container mb16 error-border" *ngIf="(isServiceError | async)">
  <div class="message-center border-box">
    <img alt="red cross error image" aria-hidden="true" class="red-cross-error-icon"
      src="ocsp-web-ui/dist/assets/images/error-close-icon.svg">
    <span class="error-messages-center">{{errorMessage}}</span>
  </div>
</div>
<div class="discount-option-container" *ngIf="!showBenefitsContainer && !showLoader">
  <div class="discount-container">
    <div class="img-tag">
      <img alt="FreshPass discount tag" class="fp-customer-details-right-arrow"
        src="ocsp-web-ui/dist/assets/images/discounts_tag.svg" />
    </div>
    <div class="img-subs">
      <img alt = "Free delivery Premium perks" class="fp-customer-details-right-arrow"
        src="ocsp-web-ui/dist/assets/images/freshpass_discounts_img.svg" />
    </div>
    <div class="discount-title">
      <p class="discount-plan-title" aria-label="Cancel Plan">
        {{properties.cancelFreshPass.discountPlanTitle}}
      </p>
      <div class="discount-plan-second-title-container">
        <p class="discount-plan-second-title" aria-label="Second Title">
          {{properties.cancelFreshPass.discountPlanSecondTitle}}.
        </p>
      </div>
      <div class="discount-btn-container">
        <button class="btn btn-primary btn-block body-m--extra-bold" id="discountBtn" type="button" aria-label="Yes, I'm interested"
          (click)="goToBenefitsInfo()">
          {{properties.cancelFreshPass.discountPlanBtnDesc}}
        </button>
        <div class="links__action__default cancel_link mt-2" role="link" tabindex="0" (click)="goToCancelPlan()" aria-label="Continue to cancel"
          (keydown.enter)="goToCancelPlan()">
          {{properties.cancelFreshPass.discountPlanCancelBtnDesc}}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="benefits-container-main" *ngIf="showBenefitsContainer && !showLoader">
  <div class="benefits-info-container">
    <div class="benefits-main-inside">
      <div class="benefits-info" *ngFor="let retentionPlan of retentionPlanDiscounts; let i = index">
        <div *ngIf="retentionPlan?.discountType === 'RetentionAnnual'" tabindex="0" >
          <p  id="benefits-info-description" class="sr-only">{{properties.cancelFreshPass.benefitsRetentionPlanAnnualForSrOnly}} ${{retentionPlan?.planPrice}} old price ${{retentionPlan?.regularPlanPrice}}</p>
          <span aria-labelledby="benefits-info-description">
            <p class="benefits-info-title" aria-hidden="true">
              {{properties.cancelFreshPass.benefitsRetentionPlanAnnual}} ${{retentionPlan?.planPrice}}
              <span class="strike-through-grey" aria-hidden="true">${{retentionPlan?.regularPlanPrice}}</span>
            </p>
          </span>
        <p class="benefits-tax-info-title">
          <span class="sr-only">{{properties.cancelFreshPass.benefitsTaxInfo}} ${{retentionPlan?.regularPlanPrice}} per year</span>
          <span aria-hidden="true">{{properties.cancelFreshPass.benefitsTaxInfo}} ${{retentionPlan?.regularPlanPrice}}/year.</span>
        </p>
      </div>
    </div>
    <div class="benefits-container">
      <span class="rectangle-offer">
        <p class="spl-txt">{{properties.cancelFreshPass.benefitsSplOffer}}</p>
      </span>
      <div class="tile-container">
        <p class="benefits-header">{{cancelBenefitsHeader}}</p>
        <div *ngFor="let tile of tileArray" class="tile">
          <span>
            <img alt = "" src="{{tile.tileImage}}" aria-hidden="true" role="img" class="fp-test">
          </span>
          <span class="title-info">
            <p [innerHTML]="tile.rteTitle"></p>
          </span>
        </div>
      </div>
    </div>
    <div class="benefits-btn-container">
      <button class="btn btn-primary--neutral-light btn-block body-m--extra-bold btn-selection ouline-btn" id="discountBtn"
        type="button" (click)="onDiscountOptionClick()">
        {{properties.cancelFreshPass.benefitsBtnDesc}}
      </button>
      <div class="links__action__default cancel_link-benefits ouline-btn" role="link" tabindex="0" (click)="goToCancelPlan()"
        (keydown.enter)="goToCancelPlan()">
        {{properties.cancelFreshPass.discountPlanCancelBtnDesc}}
      </div>
    </div>
    </div>
  </div>
</div>